import AlgoliaFactory from '@/model/algolia';
import { fetchBingoGames } from '@/model/bingo';
import { fetchBonusPermission } from '@/model/bonusPermission';
import { fetchGame, gameLaunchModel } from '@/model/game';
import { fetchJackpotBetFeedsByLiquidity } from '@/model/jackpotBet';
import { fetchLiveTables } from '@/model/liveTable';
import { fetchPage } from '@/model/page';
import { fetchRecentlyPlayed } from '@/model/recentlyPlayed';
import { fetchRecommendedGamesByAccountID } from '@/model/recommendedGamesByAccountID';
import { getCanonicalUrl } from '@/model/seo';
import { fetchShuffleGames } from '@/model/shuffleGames';
import { fetchStrikeGoldData } from '@/model/strikeGold';

const commonModel = {
  ...gameLaunchModel,
  fetchGame,
  AlgoliaFactory,
  fetchLiveTables,
  fetchPage,
  fetchRecentlyPlayed,
  getCanonicalUrl,
  fetchBingoGames,
  fetchShuffleGames,
  fetchStrikeGoldData,
  fetchRecommendedGamesByAccountID,
  fetchJackpotBetFeedsByLiquidity,
  fetchBonusPermission,
};

export default commonModel;
